module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "atbold"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm05"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/fm06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction by Ed Goeas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Part One | The Great Divide")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 1.")]), _vm._v(" Vanishing Respect: The Loss of Trust in an Uncivil Society")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 2.")]), _vm._v(" Cynicism: Many Americans Doubt There "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Are")]), _vm._v(" Solutions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 3.")]), _vm._v(" Polarization: A Deep Dive into the Great Divide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 4.")]), _vm._v(" Toxic Incentives: Bad Behavior Richly Rewarded")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Part Two | Building Bridges")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 5.")]), _vm._v(" Problem-Solving Strategies: Workable Solutions for a New Era")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 6.")]), _vm._v(" Not So Social Media: Repairing a Once Promising Connectivity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 7.")]), _vm._v(" Cable News Networks: Dousing the Flames of Discord")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 8.")]), _vm._v(" Reforms: Tackling Campaign Finance and Special Interest Privilege")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 9.")]), _vm._v(" COVID-19: A Perfect Example of Extreme Polarization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 10.")]), _vm._v(" Looking Toward a Respectful Future")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Final Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 71
// module chunks = 0